// extracted by mini-css-extract-plugin
export default {"home":"home_home__1jket","error":"home_error__FSt6I","resultImage":"home_resultImage__owR89"};